import React from 'react';
import { Check } from 'lucide-react';
import { packagesContent } from '@/hooks/useContent';

const Packages = () => {
  // Sort packages by order
  const packages = [...packagesContent].sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <section id="packages" className="py-24" style={{ backgroundColor: '#f7f5f2' }} data-testid="packages-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="section-title text-4xl md:text-5xl font-bold mb-4" data-testid="packages-title">
            Build Your Package
          </h2>
          <p className="section-subtitle text-xl max-w-3xl mx-auto" data-testid="packages-subtitle">
            Mix and match to create the perfect experience for your event. All packages are fully customizable to your preferences.
          </p>
        </div>

        {/* Packages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div 
              key={index}
              className="package-card bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
              data-testid={`package-card-${index}`}
            >
              <div 
                className="package-header p-8"
                style={{ 
                  backgroundColor: `${pkg.color}15`,
                  borderTop: `4px solid ${pkg.color}`
                }}
              >
                <h3 className="text-2xl font-bold mb-2" style={{ color: pkg.color }}>
                  {pkg.name}
                </h3>
                {pkg.subtitle && (
                  <p className="text-sm font-medium mb-2" style={{ color: pkg.color }}>
                    {pkg.subtitle}
                  </p>
                )}
                <p className="text-base" style={{ color: '#736c64' }}>
                  {pkg.description}
                </p>
              </div>
              <div className="package-content p-8">
                <ul className="space-y-4">
                  {pkg.features?.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-start gap-3">
                      <Check 
                        size={20} 
                        className="flex-shrink-0 mt-0.5"
                        style={{ color: pkg.color }}
                      />
                      <span className="text-base" style={{ color: '#1e1919' }}>
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>
                {pkg.character && (
                  <p className="mt-6 text-sm italic" style={{ color: '#736c64' }}>
                    {pkg.character}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-lg mb-6" style={{ color: '#736c64' }}>
            Want to combine packages or create something unique?
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="cta-button px-8 py-4 rounded-md font-semibold text-lg transition-all duration-300"
            data-testid="packages-cta"
          >
            Let's Create Your Perfect Package
          </button>
        </div>
      </div>
    </section>
  );
};

export default Packages;
